import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { firstValueFrom, filter } from 'rxjs';

import { environment } from '../../environments/environment';
import { UserService } from '../shared/services/user.service';

export const authGuard: CanActivateFn = async (route, state) => {
  // Skip auth guard if debug flag is enabled
  if (environment.skipAuth) {
    return true;
  }

  const userService = inject(UserService);
  const router = inject(Router);

  const isAuthenticated = await firstValueFrom(
    userService.authentication$.pipe(filter((value) => value !== null)),
  );

  if (isAuthenticated) {
    return true;
  }

  router.navigate(['login'], { queryParams: { returnUrl: state.url } });
  return false;
};
